export const PYTHON_FUNCTION_INITIAL_VALUE = `"""
Enter Python code.
Available variables:
\`input_df: pandas.DataFrame\` with data,
\`logger: Logger\`,
\`context: dict[str, Any]\`,
\`parameters: dict[str, str]\` with workflow parameters.
Assign output to \`output_df\`.
Optionally assign \`metadata: dict[str, Any]\`
that will be added to the context.

Context contains:
- project_id: UUID (ID of the project)
- execution_id: UUID (ID of the workflow execution)
- metadata: dict[str, Any] | None (metadata of the previous step)
- api_url: str (API URL)
- api_token: str (API token)
- parameters: dict[str, str] (workflow parameters)
"""
# Log the current context (optional)
logger.info(f"Context received: {context}")

# Log the parameters (optional)
logger.info(f"Workflow parameters: {parameters}")

# Perform a simple operation on the input DataFrame
# For example, adding a new column with a constant value
output_df = input_df.copy()
output_df['new_column'] = 'example_value'

# Optionally, create a metadata dictionary
metadata = {
    "message": "Transformation complete",
    "row_count": len(output_df)
}

# Log the completion of the process
logger.info("DataFrame transformation complete.")
`;

export const LOOP_EXIT_INITIAL_VALUE = `"""
Enter Python code to evaluate loop exit condition.
Available variables:
\`input_df: pandas.DataFrame\` - input data frame,
\`metadata: Dict[str, Any]\` - metadata from workflow,
\`logger: Logger\` - logger instance,
\`workflow_data: Dict[str, Any]\` - workflow execution data,
\`done: bool\` - current loop completion status.

IMPORTANT: Assign a boolean value to the \`done\` variable 
to indicate whether the loop should exit (True) or continue (False).
"""
# Log the current state (optional)
logger.info(f"Evaluating loop exit condition")
logger.info(f"Current metadata: {metadata}")
logger.info(f"DataFrame shape: {input_df.shape}")

# Example: Exit loop if DataFrame has fewer than 10 rows
# Replace this with your actual exit condition logic
done = len(input_df) < 10

# Log the decision
logger.info(f"Loop exit decision: {done}")
`;
